import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectionListItem from '@wix/da-ds/pkg/SelectionList/SelectionListItem';
var GoToTier = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(SelectionListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'), onClick: function () {
            window.location.href = deviation.url;
        } }));
};
GoToTier.displayName = 'GoToTier';
export default GoToTier;
//# sourceMappingURL=GoToTier.js.map